import { useEffect } from "react";
import { posthog } from "posthog-js";
import { CLOTHING_CUSTOM_FIT_SCAN, IdntfyStore, PARAMS_PROP, SESSION_STORAGE_KEY, JWTToken } from "../vars";
import { decodingURL, getParamsValue, getSessionStorage, hasNullSessionValue, hasNullValue, setLocalStorageData, setSessionStorage } from "../utils/util";

function useGetParams({ setShopDomain, setScanType, setEmail, setShopifyRedirectUrl, setName, setUserInfo, setGender }) {
	const handleGetParamsValue = () => {
		if (hasNullValue(PARAMS_PROP.SCAN_TYPE)) {
			setScanType(getParamsValue(PARAMS_PROP.SCAN_TYPE));
			setSessionStorage(SESSION_STORAGE_KEY.SCAN_TYPE, getParamsValue(PARAMS_PROP.SCAN_TYPE));
		} else if (hasNullSessionValue(SESSION_STORAGE_KEY.SCAN_TYPE)) {
			setScanType(getSessionStorage(SESSION_STORAGE_KEY.SCAN_TYPE));
		}
		if (hasNullValue(PARAMS_PROP.EMAIL)) {
			const value = decodingURL(getParamsValue(PARAMS_PROP.EMAIL)).replace(/ /g, "+");
			setEmail(value);
			setSessionStorage(SESSION_STORAGE_KEY.EMAIL, value);
		} else if (hasNullSessionValue(SESSION_STORAGE_KEY.EMAIL)) {
			setEmail(getSessionStorage(SESSION_STORAGE_KEY.EMAIL) ?? "");
		}
		if (hasNullValue(PARAMS_PROP.NAME)) {
			setName(getParamsValue(PARAMS_PROP.NAME));
			setSessionStorage(SESSION_STORAGE_KEY.NAME, getParamsValue(PARAMS_PROP.NAME));
		} else if (hasNullSessionValue(SESSION_STORAGE_KEY.NAME)) {
			setName(getSessionStorage(SESSION_STORAGE_KEY.NAME));
		}
		if (hasNullValue(PARAMS_PROP.CALLBACK_URL)) {
			setSessionStorage(SESSION_STORAGE_KEY.CALLBACK_URL, getParamsValue(PARAMS_PROP.CALLBACK_URL));
		}

    if (hasNullValue(PARAMS_PROP.INVITE_CODE)) {
      setSessionStorage(SESSION_STORAGE_KEY.INVITE_CODE,getParamsValue(PARAMS_PROP.INVITE_CODE));
    }
    if (hasNullValue(PARAMS_PROP.SOURCE)) {
      setSessionStorage(SESSION_STORAGE_KEY.SOURCE, getParamsValue(PARAMS_PROP.SOURCE));
    }
    if (hasNullValue(PARAMS_PROP.GENDER)) {
      setGender(getParamsValue(PARAMS_PROP.GENDER));
      setSessionStorage(SESSION_STORAGE_KEY.GENDER,getParamsValue(PARAMS_PROP.GENDER));
    }else if(hasNullSessionValue(SESSION_STORAGE_KEY.GENDER)){
      setGender(getSessionStorage(SESSION_STORAGE_KEY.GENDER));
    }
    if (hasNullValue(PARAMS_PROP.HEIGHT)) {
      setUserInfo((prev) => ({ ...prev, height: { cm: +getParamsValue(PARAMS_PROP.HEIGHT)}}));
    }else if(hasNullSessionValue(SESSION_STORAGE_KEY.HEIGHT)){
      setUserInfo((prev) => ({ ...prev, height: { cm: +getSessionStorage(SESSION_STORAGE_KEY.HEIGHT) } }));
    }
    if (hasNullValue(PARAMS_PROP.SHOPIFY_REDIRECT)) {
      setShopifyRedirectUrl(getParamsValue(PARAMS_PROP.SHOPIFY_REDIRECT));
      setSessionStorage(SESSION_STORAGE_KEY.SHOPIFY_REDIRECT_URL, getParamsValue(PARAMS_PROP.SHOPIFY_REDIRECT));
    } else if(hasNullSessionValue(SESSION_STORAGE_KEY.SHOPIFY_REDIRECT_URL)) {
      setShopifyRedirectUrl(getSessionStorage(SESSION_STORAGE_KEY.SHOPIFY_REDIRECT_URL));
    }

		if (hasNullValue(PARAMS_PROP.SHOP_DOMAIN)) {
			const value = decodingURL(getParamsValue(PARAMS_PROP.SHOP_DOMAIN));
			if (value === IdntfyStore) {
				setScanType(CLOTHING_CUSTOM_FIT_SCAN);
				setSessionStorage(SESSION_STORAGE_KEY.SCAN_TYPE, value);
			}
			setShopDomain(value);
			setSessionStorage(SESSION_STORAGE_KEY.SHOP_DOMAIN, value);
			posthog.capture("Referrer Info", { referrer: value });
		} else if (hasNullSessionValue(SESSION_STORAGE_KEY.SHOP_DOMAIN)) {
			setShopDomain(getSessionStorage(SESSION_STORAGE_KEY.SHOP_DOMAIN));
		}
		
		if (hasNullValue(PARAMS_PROP.TOKEN)) {			
			setLocalStorageData(JWTToken, getParamsValue(PARAMS_PROP.TOKEN));
		}
		if (hasNullSessionValue(SESSION_STORAGE_KEY.FOCAL_LENGTH)) {
			setUserInfo((prev) => ({ ...prev, device: { focalLength: getSessionStorage(SESSION_STORAGE_KEY.FOCAL_LENGTH), modelName: getSessionStorage(SESSION_STORAGE_KEY.MODEL_NAME) } }));
		}
		posthog.capture("fit-view Platform", { "node.env": process.env.REACT_APP_NODE.ENV });
	};

	useEffect(() => {
		handleGetParamsValue();
	}, []);
	return null;
}

export default useGetParams;
